<drawer *ngIf="institutionUnit" [title]="institutionUnit.id ? 'Edit unit' : 'Add unit'"
	[showHeaderButtons]="true"
	[hideDelete]="true"
	[hideCancel]="false"
	[hideSave]="false"
	[noContentPadding]="false"
	[isClosed]="false"
	(saveEvent)="submit()"
	(cancelEvent)="closeLayer()"
	(closeEvent)="closeLayer()">
	<div class="drawer-content drawer-direct-content">
		<form name="institutionForm" role="form">
			<div class="row fields-group mt-4">
				<div
					class="{{
					context === 'table' ? 'col-lg-4' : 'col-lg-6'
					}} col-md-12 mb-3 mb-lg-0"
				>
					<label class="input-label field-required">{{
					'annexes.inst.name_placeholder' | translate
					}}</label>
					<input
					class="form-control"
					type="text"
					name="name"
					#name="ngModel"
					[(ngModel)]="institutionUnit.name"
					placeholder="{{ 'annexes.inst.name_placeholder' | translate }}"
					[rangeLength]="[2, 256]"
					required
					autofocus
					/>
					<p
					class="validation-error"
					*ngIf="name.errors?.required && (name?.dirty && name?.touched)"
					>
					{{ 'form.validate.required' | translate }}
					</p>
					<p class="validation-error" *ngIf="name.errors?.rangeLength && (name?.dirty && name?.touched)">
					{{ 'form.validate.minLenght' | translate }} 2!
					</p>
					<p class="validation-error" *ngIf="name.errors?.rangeLength && (name?.dirty && name?.touched)">
					{{ 'form.validate.maxLenght' | translate }} 256!
					</p>
				</div>
				<div class="col-md-4" *ngIf="context === 'table'">
					<label class="input-label">{{
					'annexes.units.institution' | translate
					}}</label>
					<select
					class="form-control"
					name="institution"
					[(ngModel)]="institutionUnit.institution_id"
					#institution="ngModel"
					[disabled]="keycloakActive && institutionUnit.id"
					required
					>
					<option
						*ngFor="let o of registrationInstitutions"
						[ngValue]="o.id"
						>{{ o.name }}</option
					>
					</select>
					<p
					class="validation-error"
					*ngIf="institution.errors?.required && (institution?.dirty && institution?.touched)"
					>
					{{ 'form.validate.required' | translate }}
					</p>
				</div>
				<div
					class="{{
					context === 'table' ? 'col-lg-4' : 'col-lg-6'
					}} col-md-12 mb-3 mb-lg-0"
				>
					<label class="input-label">{{
					'annexes.inst.url_placeholder' | translate
					}}</label>
					<input
					class="form-control"
					type="text"
					name="url"
					[(ngModel)]="institutionUnit.url"
					#url="ngModel"
					placeholder="{{ 'annexes.inst.url_placeholder' | translate }}"
					/>
          		</div>
			</div>
		</form>
	</div>
</drawer>